import { useContext } from "react"
import { MultiContext } from "~/contexts/MultiContext"

export function useVideoDimensions(position, focused) {
  const { gridConfig, dimensions, breakpoint } = useContext(MultiContext)

  const large = gridConfig.large.includes(position)
  const singleColumn = breakpoint === ""

  if (focused) return dimensions.focus
  if (singleColumn) return dimensions.single
  if (large) return dimensions.large

  return dimensions.normal
}
